import React from 'react';

export const name = 'hamburger';

export const Hamburger = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.375 6L2.625 6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M21.375 12L2.625 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
    <path
      d="M21.375 18L2.7975 18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="bevel"
    />
  </svg>
);
